// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Jumbotron-module--Wrapper--3TTTM","Headline":"Jumbotron-module--Headline--2YDmp","Subtitle":"Jumbotron-module--Subtitle--3hHr1"};